import Typography from '@material-ui/core/Typography';
import strings from 'strings';
import { When } from 'UI/components/atoms';
import FPIcon from 'UI/components/atoms/FPIcon';
import { DateFormats } from 'UI/constants/defaults';
import { localTimeFormatter } from 'UI/utils';

import { useStyles } from './EntitySummary.styled';

const COPIES = strings.inventoryProfiles.common;

/**
 * Right column of the summary band: "Added Date", "Added By" and the entity details, empty
 * ones dropped. Copied from V1 InventoryProfileLayout/EntitySummary, which is deleted with V1.
 * @param {Object} props
 * @param {{ creationDate?: string, creationBy?: string }} props.summaryContentProps
 * @param {Array<{ title: string, content: string, icon?: Function }>} [props.summaryLabels]
 */
export const EntitySummary = ({ summaryContentProps, summaryLabels = [] }) => {
  const classes = useStyles();

  const labels = [
    {
      title: COPIES.summaryLabelDate,
      content: localTimeFormatter(summaryContentProps.creationDate, DateFormats.SimpleDateTime)
    },
    { title: COPIES.summaryLabelCreationBy, content: summaryContentProps.creationBy },
    ...summaryLabels
  ];
  const labelsWithContent = labels.filter(item => item.content && item.title);

  return (
    <div className={classes.profileLabel}>
      {labelsWithContent.map(item => (
        <Typography
          className={classes.overline}
          color="textSecondary"
          component="span"
          variant="overline"
          key={item.title}
        >
          <strong>
            {`${item.title}: `}
            <When condition={item.icon}>
              <FPIcon
                component={item.icon}
                size={14}
                color="inherit"
                className={classes.successIcon}
              />
            </When>
          </strong>
          {item.content}
        </Typography>
      ))}
    </div>
  );
};
